// #region imports
import { makeStyles, createStyles } from '@mui/styles';
import { Theme } from '@mui/material';
// #endregion

export default makeStyles<Theme>(theme =>
  createStyles({
    root: {
      border: `2px solid ${theme.palette.common.white}`,
      borderRadius: 6,
      background: '#5845FF9E',
      '& .MuiTableRow-root': {
        height: 35,
        '&:not(:last-child)': {
          borderBottom: `1px solid ${theme.palette.common.white}`
        },
        [theme.breakpoints.up('md')]: {
          height: 66
        }
      },
      '& .MuiTableCell-root': {
        fontSize: 18,
        lineHeight: '20px',
        padding: '20px 10px',
        fontWeight: 700,
        color: theme.palette.common.white
      },
      '& th': {
        fontWeight: 400
      },
      [theme.breakpoints.up('md')]: {
        '& .MuiTableCell-root': {
          fontSize: 18,
          padding: '20px 20px'
        }
      }
    },
    winerCell: {
      '&.MuiTableCell-root': {
        fontWeight: 400,
        fontSize: 18,
        [theme.breakpoints.up('md')]: {
          fontWeight: 700
        }
      }
    },
    price: {
      display: 'flex',
      alignItems: 'center',
      gap: 8,
      width: 100,
      '& span': {
        whiteSpace: 'nowrap'
      },
      '& svg': {
        flexShrink: 0
      }
    },
    superPrizeLabel: {
      fontWeight: 400,
      fontSize: 20,
      marginBottom: 5
    },
    superPrize: {
      fontWeight: 700,
      fontSize: 28,
      whiteSpace: 'nowrap',
      width: 100,
      [theme.breakpoints.up('md')]: {
        fontSize: 26
      }
    }
  }), { name: 'PrizeFondTable' }
);
